import React, { type ReactNode } from 'react';
import { tv } from '@/utils/tv';

const card = tv({
  base: 'flex flex-col gap-4 rounded-2xl bg-card p-4 shadow-card',
  variants: {
    isInteractive: {
      true: 'cursor-pointer text-left',
    },
  },
});

interface Props {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<Props> = ({ children, className, onClick }) => {
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={card({ isInteractive: true, className })}
      >
        {children}
      </button>
    );
  }

  return <div className={card({ className })}>{children}</div>;
};
